import Tray from './index'
import React from 'react'


const CategoryTray = (props) => {
  return (
    <div className="netflix-tray category-tray">
      <Tray {...props} showCount={true} netflix={true} hideCategories={true} neouTrayTitle={true}/>
    </div>
  )
}


export default CategoryTray;
